import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const IconLogiciel = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        id="Tracé_10584"
        data-name="Tracé 10584"
        d="M0,0H48V48H0Z"
        fill="none"
      />
      <g id="XMLID_816_" transform="translate(6 6)">
        <g id="XMLID_1663_">
          <g id="XMLID_709_">
            <path
              id="XMLID_710_"
              d="M231.633,364.99a.7.7,0,1,0,.5.206A.708.708,0,0,0,231.633,364.99Z"
              transform="translate(-214.693 -339.327)"
              fill="#272727"
            />
            <path
              id="XMLID_734_"
              d="M422.473,335.12a.7.7,0,1,0,.5.206A.709.709,0,0,0,422.473,335.12Z"
              transform="translate(-392.114 -311.557)"
              fill="#272727"
            />
            <path
              id="XMLID_735_"
              d="M126.642,287a.7.7,0,1,0,.5.206A.708.708,0,0,0,126.642,287Z"
              transform="translate(-117.084 -266.82)"
              fill="#272727"
            />
            <path
              id="XMLID_744_"
              d="M36,7.632a.7.7,0,0,0-.7-.7H34.214a7.6,7.6,0,0,0-.59-1.424l.765-.765a.7.7,0,0,0,0-.994L32.256,1.61a.7.7,0,0,0-.994,0l-.765.765a7.6,7.6,0,0,0-1.424-.59V.7a.7.7,0,0,0-.7-.7H25.35a.7.7,0,0,0-.7.7V1.789a7.6,7.6,0,0,0-1.421.59l-.768-.768a.7.7,0,0,0-.994,0L19.329,3.744a.7.7,0,0,0-.2.615H2.815A2.818,2.818,0,0,0,0,7.174v19.4a2.818,2.818,0,0,0,2.815,2.815H13.987v2.391H12.3a2.537,2.537,0,0,0-2.534,2.534V35.3a.7.7,0,0,0,.7.7H23.409a.7.7,0,0,0,.7-.7v-.982a2.537,2.537,0,0,0-2.534-2.534H19.893V29.391H31.059a2.818,2.818,0,0,0,2.815-2.815V15.053l.516-.516a.7.7,0,0,0,0-.994l-.768-.768a7.6,7.6,0,0,0,.59-1.421H35.3a.7.7,0,0,0,.7-.7ZM22.706,34.315v.279H11.175v-.279A1.129,1.129,0,0,1,12.3,33.188h9.276A1.129,1.129,0,0,1,22.706,34.315Zm-4.219-2.534H15.393V29.391h3.094Zm13.981-5.205a1.41,1.41,0,0,1-1.409,1.409H2.815a1.41,1.41,0,0,1-1.409-1.409V24.969h26.14a.7.7,0,0,0,0-1.406H1.406V21.586H6.773a.7.7,0,0,0,0-1.406H1.406V7.174A1.41,1.41,0,0,1,2.815,5.766H19.969a7.6,7.6,0,0,0-.456,1.163H18.422a.7.7,0,0,0-.7.7V10.65a.7.7,0,0,0,.7.7h1.094a7.606,7.606,0,0,0,.587,1.415l-.774.774a.7.7,0,0,0,0,.994l2.134,2.134a.7.7,0,0,0,.994,0l.774-.774a7.6,7.6,0,0,0,1.415.587v1.094a.7.7,0,0,0,.7.7h3.018a.7.7,0,0,0,.7-.7V16.487A7.6,7.6,0,0,0,30.49,15.9l.771.771a.7.7,0,0,0,.994,0l.212-.212V26.576ZM34.594,9.947h-.925a.7.7,0,0,0-.687.551,6.212,6.212,0,0,1-.834,2.009.7.7,0,0,0,.095.877l.656.656-1.14,1.14-.658-.658a.7.7,0,0,0-.812-.132.693.693,0,0,0-.063.036,6.212,6.212,0,0,1-2.008.83.7.7,0,0,0-.552.687v.932H26.053v-.934a.7.7,0,0,0-.551-.687,6.213,6.213,0,0,1-2.005-.832.7.7,0,0,0-.876.1l-.661.661-1.14-1.14.661-.661a.7.7,0,0,0,.095-.877,6.212,6.212,0,0,1-.831-2,.7.7,0,0,0-.687-.551h-.934V8.335h.932a.7.7,0,0,0,.687-.552,6.211,6.211,0,0,1,.829-2.007.7.7,0,0,0-.095-.877l-.658-.658L21.96,3.1l.656.656a.7.7,0,0,0,.887.088,6.209,6.209,0,0,1,2-.828.7.7,0,0,0,.551-.686V1.406h1.612v.923a.7.7,0,0,0,.552.687,6.212,6.212,0,0,1,2.013.833.7.7,0,0,0,.876-.1l.652-.652,1.14,1.14-.652.652a.7.7,0,0,0-.095.877,6.209,6.209,0,0,1,.832,2.012.7.7,0,0,0,.687.552h.923V9.947Z"
              fill="#272727"
            />
            <path
              id="XMLID_999_"
              d="M324.359,68a4.359,4.359,0,1,0,4.359,4.359A4.364,4.364,0,0,0,324.359,68Zm0,7.313a2.953,2.953,0,1,1,2.953-2.953A2.956,2.956,0,0,1,324.359,75.313Z"
              transform="translate(-297.5 -63.219)"
              fill="#272727"
            />
            <path
              id="XMLID_1012_"
              d="M154.373,187.22a.7.7,0,1,0,.5.206A.707.707,0,0,0,154.373,187.22Z"
              transform="translate(-142.865 -174.056)"
              fill="#272727"
            />
            <path
              id="XMLID_1094_"
              d="M96.272,122.347a.7.7,0,0,0-.07-.534l-1.187-2.056a.7.7,0,0,0-.96-.257l-.676.39a4.448,4.448,0,0,0-.7-.407v-.78a.7.7,0,0,0-.7-.7H89.6a.7.7,0,0,0-.7.7v.78a4.452,4.452,0,0,0-.7.407l-.676-.39a.7.7,0,0,0-.96.257l-1.187,2.056a.7.7,0,0,0,.257.96l.677.391c-.012.135-.018.27-.018.406s.006.271.018.406l-.677.391a.7.7,0,0,0-.257.96l1.187,2.056a.7.7,0,0,0,.96.257l.676-.39a4.446,4.446,0,0,0,.7.407v.78a.7.7,0,0,0,.7.7h2.374a.7.7,0,0,0,.7-.7v-.78a4.453,4.453,0,0,0,.7-.407l.676.39a.7.7,0,0,0,.96-.257l1.187-2.056a.7.7,0,0,0-.257-.96l-.677-.391c.012-.135.018-.271.018-.406s-.006-.271-.018-.406l.677-.391A.7.7,0,0,0,96.272,122.347Zm-2.457.59a3.126,3.126,0,0,1,0,1.267.7.7,0,0,0,.337.752l.481.277-.484.838-.481-.278a.7.7,0,0,0-.82.085,3.073,3.073,0,0,1-1.1.633.7.7,0,0,0-.484.668v.555H90.3v-.555a.7.7,0,0,0-.484-.668,3.074,3.074,0,0,1-1.1-.633.7.7,0,0,0-.82-.085l-.481.278-.484-.838.481-.277a.7.7,0,0,0,.337-.752,3.129,3.129,0,0,1,0-1.267.7.7,0,0,0-.337-.752l-.481-.277.484-.838.481.278a.7.7,0,0,0,.82-.085,3.073,3.073,0,0,1,1.1-.633.7.7,0,0,0,.484-.668v-.555h.968v.555a.7.7,0,0,0,.484.668,3.073,3.073,0,0,1,1.1.633.7.7,0,0,0,.82.085l.481-.278.484.838-.481.277A.7.7,0,0,0,93.815,122.937Z"
              transform="translate(-79.277 -109.703)"
              fill="#272727"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default IconLogiciel;
